import React, { useContext, useEffect, useRef, useState } from 'react';
import classes from './OnboardingWidget.module.scss';
import { OnboardingTitle } from '../OnboardingTitle';
import { CSSTransition } from 'react-transition-group';
import { OnboardingContext } from '../states/OnboardingProvider';
import classNames from 'classnames';
import { OnboardindContent } from '../OnboardindContent';
import { useDidMount } from '../../../hooks/useDidMount';
import { useLocation, useNavigate } from 'react-router-dom';
import { Confetti } from '../../../components/containers/Confetti';
import { useReactiveVar } from '@apollo/client';
import { socialOAuthVar } from '../../../providers/AppProvider';

export const OnboardingWidgetView = (): JSX.Element => {
  const nodeRef = useRef<HTMLDivElement | null>(null);
  const { state, showOnboarding, dispatch } = useContext(OnboardingContext);
  const { isCongrats, expanded, progress, activeStepIndex } = state;
  const [visible, setVisible] = useState<boolean>(false);
  const { pathname: currentTarget } = useLocation();
  const navigate = useNavigate();
  const socialOAuth = useReactiveVar(socialOAuthVar);

  useEffect(() => {
    activeStepIndex > -1 && dispatch({ type: 'toggleExpanded', payload: true });
  }, [activeStepIndex, dispatch]);

  useEffect(() => {
    setVisible(showOnboarding);
  }, [showOnboarding]);

  // on initial load make sure we check if we should redirect to the uncompleted step
  useDidMount(() => {
    const firstUncompletedStepIndex = progress.findIndex(step => !step.completed);
    // if we are adding profile and coming back from the 3rd party with oAuth token, we don't want to do any redirects
    if (firstUncompletedStepIndex > 0 && !socialOAuth) {
      const forcedRedirect = progress[firstUncompletedStepIndex - 1].route;
      // Post editor is the last step, so we will never need to open it as the last active step
      // that is why we don't need to check for the post editor index and open it
      if (forcedRedirect && currentTarget !== forcedRedirect) {
        navigate({ pathname: forcedRedirect });
      }
    }
    return () => {
      state.ref.current = null;
    };
  });

  return (
    <CSSTransition in={visible} timeout={300} classNames={'slideup'} unmountOnExit nodeRef={nodeRef}>
      <div
        ref={ref => {
          if (ref) {
            nodeRef.current = ref;
            state.ref = nodeRef;
          }
        }}
        className={classNames(
          classes.OnboardingWidget,
          expanded ? classes.OnboardingWidgetExpanded : classes.OnboardingWidgetCollapsed
        )}>
        <OnboardingTitle />
        <OnboardindContent />
        {isCongrats && <Confetti confettiesNumber={350} confettiRadius={6} />}
      </div>
    </CSSTransition>
  );
};
